var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, transient } from "aurelia-dependency-injection";
import { ChildComponent } from "../../../../pages/modules/child-component";
import { NotificationClientService, NotificationType } from "../../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
import * as Enumerable from "linq";
import { QueriesClientService } from "../../../../../services/queries/queries-client.services";
import { DialogClientService } from "../../../../../services/basics/dialog-client.service";
import { DialogServiceConstants } from "../../../../../constants/basics/dialog.constants";
var LotteryPriceTiers = /** @class */ (function (_super) {
    __extends(LotteryPriceTiers, _super);
    function LotteryPriceTiers(notificationService, i18N, queriesService, dialogClient) {
        var _this = _super.call(this, notificationService, i18N) || this;
        _this.notificationService = notificationService;
        _this.queriesService = queriesService;
        _this.dialogClient = dialogClient;
        _this.canUpdatePriceTier = true;
        _this.isShowAddPriceTicketButton = false;
        _this.removeLastVisitedTabCache = true;
        _this.isShowcombobox = false;
        return _this;
    }
    Object.defineProperty(LotteryPriceTiers.prototype, "isFonb", {
        // FONB flag exposed to the tier repeat (where `item` is shadowed by the tier).
        get: function () {
            return !!this.item && !!this.item.isFonb;
        },
        enumerable: false,
        configurable: true
    });
    LotteryPriceTiers.prototype.onActivated = function (item) {
        if (!item.lotteryPriceTiers) {
            item.lotteryPriceTiers = [];
        }
        else {
            var checkArrayJackpotRange = Enumerable.from(item.lotteryPriceTiers).toArray(); // fixed for dashboard onload undefined error for lotteryJackpotRanges
            if (checkArrayJackpotRange.length != 0) {
                var get1stItemFromJackpot_1 = Enumerable.from(item.lotteryPriceTiers).toArray()[0].lotteryJackpotRanges; // check with jackpot tier with ranges.
                for (var i = 0; i < get1stItemFromJackpot_1.length; i++) {
                    var listLotteryBrandPriceModel = Enumerable.from(item.lotteryPricingModels).selectMany(function (x) { return x.lotteryBrandPrices; })
                        .where(function (x) { return x.lotteryJackpotRangeId == get1stItemFromJackpot_1[i].lotteryJackpotRangeId; }).select(function (x) { return x.lotteryPricingModelId; }).toArray();
                    if (listLotteryBrandPriceModel.length == 0) {
                        // display show button to redicrect the page for enter ticket price.
                        this.isShowAddPriceTicketButton = true;
                    }
                }
            }
        }
        // FONB tiers must be Fixed Amount + Per Player (validation enforces this on save) - default them here
        // so the relaxed Tier-1 controls show the correct state when the operator opens an existing FONB lottery.
        if (item.isFonb && item.lotteryPriceTiers) {
            item.lotteryPriceTiers.forEach(function (tier) {
                tier.isFixedAmount = true;
                tier.isPerPlayer = true;
            });
        }
    };
    // add ticket price by operators
    LotteryPriceTiers.prototype.addTicketPrice = function () {
        this.isShowcombobox = true;
        require("../dialogs/brandlotteryoperator-dialog-host");
        var brandsAndOperatorsModel = {
            lotteryId: this.item.lotteryId,
            lotteryName: this.item.name
        };
        this.dialogClient.show(DialogServiceConstants.URLs.BrandLotteryOperatorDialog, brandsAndOperatorsModel, true, true);
    };
    LotteryPriceTiers.prototype.removePriceTier = function (priceTierItem) {
        var _this = this;
        require("../../dialogs/delete-modal"); // this is to show delete modal dialog
        this.dialogClient.show(DialogServiceConstants.URLs.DeleteModalConfirmation, {
            delete: function () { return new Promise(function (resolve, reject) {
                resolve();
                var index = _this.item.lotteryPriceTiers.indexOf(priceTierItem);
                _this.item.lotteryPriceTiers.splice(index, 1);
                _this.dialogClient.hide();
            }); }
        });
    };
    LotteryPriceTiers.prototype.onChangeRangeToInput = function (eventInput, priceTierItem, range) {
        eventInput = eventInput.replace(/,/g, '');
        var rangetoval = +eventInput;
        var index = priceTierItem.lotteryJackpotRanges.indexOf(range);
        var getcurrentitem = priceTierItem.lotteryJackpotRanges[index];
        if (getcurrentitem.rangeFrom > rangetoval) {
            this.notificationService.show("Validation Error!", "Range To should be greater than Range From", NotificationType.Error);
        }
        else {
            if (priceTierItem.lotteryJackpotRanges[index + 1] != undefined) {
                priceTierItem.lotteryJackpotRanges[index + 1].rangeFrom = rangetoval + 1;
            }
        }
    };
    LotteryPriceTiers.prototype.onChangeRangefromInput = function (eventInput, priceTierItem, range) {
        var index = priceTierItem.lotteryJackpotRanges.indexOf(range);
        if (index > 0) {
            eventInput = eventInput.replace(/,/g, '');
            var rangefromval = +eventInput;
            priceTierItem.lotteryJackpotRanges[index - 1].rangeTo = rangefromval - 1;
            var getcurrentitem = priceTierItem.lotteryJackpotRanges[index];
            if (rangefromval > getcurrentitem.rangeTo) {
                this.notificationService.show("Validation Error!", "Range To should be greater than Range From", NotificationType.Error);
            }
        }
    };
    LotteryPriceTiers.prototype.removeJackpotRange = function (priceTierItem, range) {
        var _this = this;
        // validation for range from and range on remove jackpot range 
        var isRangeInBrandPricingModels = Enumerable.from(this.item.lotteryPricingModels)
            .selectMany(function (x) { return x.lotteryBrandPrices; }).any(function (x) { return x.lotteryJackpotRangeId != null && x.lotteryJackpotRangeId == range.lotteryJackpotRangeId; });
        // User cannot able to delete the range from jackpot tier, when jackpot range has ticket price assigned and saved in lottery brand pricing model table, 
        if (!isRangeInBrandPricingModels) {
            var index_1 = priceTierItem.lotteryJackpotRanges.indexOf(range);
            if (priceTierItem.lotteryJackpotRanges[index_1 + 1] === undefined || (priceTierItem.lotteryJackpotRanges[index_1].rangeFrom == 0 && priceTierItem.lotteryJackpotRanges[index_1].rangeTo == 0)) {
                require("../../dialogs/delete-modal"); // this is to show delete modal dialog
                this.dialogClient.show(DialogServiceConstants.URLs.DeleteModalConfirmation, {
                    delete: function () { return new Promise(function (resolve, reject) {
                        resolve();
                        // when confirm to delete, range is going to be delete.
                        priceTierItem.lotteryJackpotRanges.splice(index_1, 1);
                        _this.dialogClient.hide();
                    }); }
                });
            }
            else {
                this.notificationService.show("Validation Error!", "Cannot create a gap between the Jackpot ranges. ", NotificationType.Error);
            }
        }
        else {
            this.notificationService.show("Validation Error!", "Cannot delete the range because it has at least one ticket price set for this range. First delete the ticket price from the brand/operator and then you would be able to delete the range.", NotificationType.Error);
        }
    };
    LotteryPriceTiers.prototype.removeFxPayout = function (priceTierItem, payout) {
        var index = priceTierItem.lotteryPriceTierFixedPayouts.indexOf(payout);
        priceTierItem.lotteryPriceTierFixedPayouts.splice(index, 1);
    };
    LotteryPriceTiers.prototype.addPriceTier = function () {
        // Checking if the of the lottery price tier is zero.if it is zero than it means that this is the jackpot tier since first item is always the jackpot
        var isJackpot = (this.item.lotteryPriceTiers.length == 0) ? true : false;
        var tier = {
            name: "",
            internalName: "",
            isJackpot: isJackpot,
            lotteryId: this.item.lotteryId,
            minimumWinners: 0,
            brandInsurancePolicies: [],
            operatorInsurancePolicies: [],
            lotteryJackpotRanges: [],
            lotteryPriceTierFixedPayouts: [],
            odds: 0,
            sequenceNumber: 0,
            winningAmount: 0,
            fallbackPrize: 0,
            lotteryTierClassId: 0,
            // FONB tiers are always fixed-amount per-player (prize = ticket price x multiple); enforced on save.
            isFixedAmount: this.item.isFonb ? true : false,
            isPerPlayer: this.item.isFonb ? true : false,
            mayPayoutPerTier: null,
            insuranceTierName: "",
            increaseJackpotPercentage: 0,
            payoutMultiple: this.item.isFonb ? 0 : undefined
        };
        this.item.lotteryPriceTiers.push(tier);
    };
    LotteryPriceTiers.prototype.addJackpotRange = function (priceTierItem) {
        // range from and range to validation on add jackpot
        var rangefrom = 0;
        var rangeto = 0;
        if (priceTierItem.lotteryJackpotRanges.length != 0) {
            var getlastitem = priceTierItem.lotteryJackpotRanges[priceTierItem.lotteryJackpotRanges.length - 1];
            if (getlastitem.rangeTo == 0) {
                return this.notificationService.show("Validation Error!", "Enter valid Range To field.", NotificationType.Error);
            }
            else if (getlastitem.rangeTo <= getlastitem.rangeFrom) {
                return this.notificationService.show("Validation Error!", "Range To should be greater than Range From.", NotificationType.Error);
            }
            rangefrom = getlastitem.rangeTo + 1;
        }
        var range = {
            lotteryPriceTierId: priceTierItem.lotteryPriceTierId,
            rangeFrom: rangefrom,
            rangeTo: rangeto
        };
        priceTierItem.lotteryJackpotRanges.push(range);
    };
    LotteryPriceTiers.prototype.addFxPayout = function (item) {
        var payout = {
            lotteryPriceTierId: item.lotteryPriceTierId,
            currencyId: 0,
            payout: 0
        };
        item.lotteryPriceTierFixedPayouts.push(payout);
    };
    LotteryPriceTiers = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [NotificationClientService, I18N, QueriesClientService, DialogClientService])
    ], LotteryPriceTiers);
    return LotteryPriceTiers;
}(ChildComponent));
export { LotteryPriceTiers };
